<template>
  <div>
    <v-card class="mx-auto" width="256" tile>
      <v-navigation-drawer permanent>
        <div class="text-center" style="padding-top: 20px;">
          <v-chip class="ma-2" color="deep-purple darken-1" text-color="white">
            <v-avatar left>
              <v-icon small>mdi-office-building-marker-outline</v-icon>
            </v-avatar>
            <strong>hObjects</strong> Properties
          </v-chip>
        </div>
        <v-divider></v-divider>
        <v-container>
          <v-tooltip top color="#311B92">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-text-field
                  background-color="deep-purple lighten-5"
                  dense
                  label="Name"
                  placeholder="Name..."
                  filled
                  disabled
                  v-model="hObject.name"
                ></v-text-field>
              </div>
            </template>
            <span v-text="hObject.name"></span>
          </v-tooltip>

          <v-text-field
            background-color="deep-purple lighten-5"
            dense
            label="Type"
            placeholder="Type"
            filled
            disabled
            v-model="hObject.type"
          ></v-text-field>

          <v-switch
            dark
            dense
            v-model="hObject.allowRegistration"
            label="Allow Registration"
            color="deep-purple darken-1"
            hide-details
          ></v-switch>

          <v-switch
            dark
            dense
            v-model="hObject.registered"
            label="Registered"
            color="deep-purple darken-1"
            hide-details
          ></v-switch>

          <v-switch
            dark
            dense
            v-model="hObject.visible"
            label="Visible"
            color="deep-purple darken-1"
            hide-details
          ></v-switch>

          <v-expansion-panels dark multiple tile>
            <v-expansion-panel style="background: rgba(0,0,0,0.2);">
              <v-expansion-panel-header>Position</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-text-field
                  dark
                  dense
                  label="X"
                  placeholder="x"
                  outlined
                  type="number"
                  v-model="hObject.position.x"
                ></v-text-field>
                <v-text-field
                  dark
                  dense
                  label="Y"
                  placeholder="y"
                  outlined
                  type="number"
                  v-model="hObject.position.y"
                ></v-text-field>
                <v-text-field
                  dark
                  dense
                  label="Z"
                  placeholder="z"
                  outlined
                  type="number"
                  v-model="hObject.position.z"
                ></v-text-field>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel style="background: rgba(0,0,0,0.2);">
              <v-expansion-panel-header>Rotation</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-text-field
                  dark
                  dense
                  label="X"
                  placeholder="x"
                  outlined
                  type="number"
                  v-model="hObject.rotation.x"
                ></v-text-field>
                <v-text-field
                  dark
                  dense
                  label="Y"
                  placeholder="y"
                  outlined
                  type="number"
                  v-model="hObject.rotation.y"
                ></v-text-field>
                <v-text-field
                  dark
                  dense
                  label="Z"
                  placeholder="z"
                  outlined
                  type="number"
                  v-model="hObject.rotation.z"
                ></v-text-field>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
      </v-navigation-drawer>
    </v-card>
    <br />

    <WidgetPropertiesComponent
      v-if="hObject.widgets !== undefined"
      v-for="(widget, iWidget) in hObject.widgets"
      :key="iWidget"
      :widget="widget"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { EventBus } from '@/js/EventBus.js'

import WidgetPropertiesComponent from '@/components/Widget/Properties'

export default {
  name: 'hObjectPropertiesComponent',
  components: {
    WidgetPropertiesComponent
  },
  data() {
    return {}
  },
  props: {
    hObject: {
      required: true,
      type: Object,
      default: {
        name: ''
      }
    }
  },
  methods: {}
}
</script>

<style scoped>
.v-card {
  background-color: rgba(0, 0, 0, 0.4);
  color: white;
  border: 1px solid #626f76;
  margin-bottom: 0.2rem;
}

.v-navigation-drawer {
  background-color: rgba(0, 0, 0, 0) !important;
}

.v-icon {
  color: #ede7f6;
}

.v-list-item__title {
  color: #ede7f6;
}

.v-list-item:hover {
  background-color: #4527a0;
}

.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HObject/Properties.vue